import { ModelSagres } from "../../model-sagres";
import { Licitacao } from "../ldi/licitacao";
import { Contrato } from "./contrato";

export class ContratoLicitacaoPropria extends ModelSagres {
  IdContrato: number;
  IdLicitacao: number;

  IdContratoNavigation: Contrato;
  IdLicitacaoNavigation: Licitacao;
}
